import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isPropertySpan',
})
export class PropertySpanPipe implements PipeTransform {
  PropertyTypeIds = new Set([227, 228]);
  transform(permissionTypeId: number): boolean {
    return this.PropertyTypeIds.has(permissionTypeId);
  }
}
